module.exports = __webpack_public_path__ + "static/media/blueberry-collected.2345612a.png";